import { formatDate } from '@frontend/mwm-ui'
import classNames from 'classnames'
import { forwardRef } from 'react'
import { MdOutlineCalendarToday } from 'react-icons/md'

import type { Props } from '../../TextInput'

import Input from '../../TextInput'

const MainInput = forwardRef<
  HTMLInputElement,
  Exclude<Props, 'size'> & {
    customValues: string[]
    withRange?: boolean
  }
>(({ className, customValues, value: datepickerValue, withRange, ...props }, ref) => {
  /** Local state */

  const classes = classNames('main-input', className, { 'with-range': withRange })

  const [startDate, endDate] = customValues || []

  const formattedStartDate = formatDate(startDate)

  const formattedEndDate = formatDate(endDate)

  const value = withRange
    ? startDate && endDate
      ? `${formattedStartDate} - ${formattedEndDate}`
      : ''
    : datepickerValue

  /** Render */

  return (
    <Input
      {...props}
      className={classes}
      icon={<MdOutlineCalendarToday size={18} />}
      readOnly={withRange}
      ref={ref}
      value={value}
    />
  )
})

MainInput.displayName = 'MainInput'

export default MainInput
